import React from "react";
import classes from "./style.module.css";

const FilterItem = ({ title, selected, handleClick }) => {
  return (
    <div
      className={`${classes.filterItem} ${
        selected  ? classes.selected : ""
      }`}
      onClick={handleClick}
    >
      {title}
    </div>
  );
};

export default FilterItem;
